import { usePosUserLockScreenStore } from 'src/services/pos/PosUserLockScreen/posUserLockScreenStore';

export function usePosUserLockScreenIsWrongPassword(): boolean {
    return usePosUserLockScreenStore((state) => state.isWrongPassword);
}
